import React from "react";

import { LockIcon, POIIcon } from "@/assets/icons";
import Badge from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface DatasetItemProps {
  name: string;
  isLocked?: boolean;
  isSelection?: boolean;
  checked?: boolean;
  onChange?: () => void;
  onClickLockIcon?: () => void;
}

export const DatasetItem: React.FC<DatasetItemProps> = ({
  name,
  isLocked = false,
  isSelection = false,
  checked = false,
  onChange,
  onClickLockIcon
}) => {
  return (
    <button
      onClick={isSelection ? onChange : undefined}
      className={cn(
        "flex items-center gap-2 p-2 rounded-xl border transition-all cursor-auto w-full",
        isSelection ? "cursor-pointer" : "",
        isSelection && checked
          ? "bg-[#E6F4F1] border-[#2D8C7F]"
          : "bg-white border-gainsboro"
      )}
    >
      {/* Icon */}
      <div className="p-1 rounded-md bg-blue-50 flex items-center justify-center shrink-0">
        <POIIcon className="w-4 h-4 fill-blue-300" />
      </div>

      {/* Content */}
      <div className="flex items-center justify-between w-full">
        <span className="text-xs text-txtHeading font-['Plus_Jakarta_Sans']">
          {name}
        </span>

        {/* Right side */}
        {isSelection ? (
          <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            onClick={(e) => e.stopPropagation()}
            className="w-4 h-4 accent-[#2D8C7F]"
          />
        ) : (
          isLocked && (
            <Badge
              className={cn(
                "bg-[#E37900] border-[#E37900] p-[2px]",
                onClickLockIcon ? "cursor-pointer" : ""
              )}
              onClick={onClickLockIcon}
            >
              <LockIcon
                className="fill-white"
                aria-label="Locked dataset"
                title="Locked dataset"
              />
            </Badge>
          )
        )}
      </div>
    </button>
  );
};
